enum ActivityStyle {
	Monetary = 0,
	Physical = 1,
}

export default ActivityStyle;